import instaclustrComponent from "./Components";

export class Component extends instaclustrComponent {
    constructor(name, node) {
        super(name, node);
    }
    init() {
        console.log(this.name);

        // Tabby.min.js documentation:
        // https://github.com/cferdinandi/tabby

        // Get all tabbed content components
        let $tabs  = jQuery('.component-feature-tabs-2024');
        // Support for up to 3 tabbed components
        let tabComponent;
        let tabComponent2;
        let tabComponent3;
        console.log($tabs.length);

        // Init Tabby
        if ($tabs.length > 0) {
            $tabs.each(function(i) {
                let $tabId = $(this).attr('data-js-tabs');
                if (i === 0) {
                    tabComponent = new Tabby(`[data-tabs-` + $tabId + `]`);
                }
                if (i === 1) {
                    tabComponent2 = new Tabby(`[data-tabs-` + $tabId + `]`);
                }
                if (i === 2) {
                    tabComponent3 = new Tabby(`[data-tabs-` + $tabId + `]`);
                }
            })
        }

        // Mobile select functionality
        // TODO: make this work with multiple Tabbys on a page
        let $selectMenu = $('.component-feature-tabs-2024 select.tabs-select');

        $selectMenu[0].addEventListener('change', (event) => {
            const selectedId = event.target.value;
            tabComponent.toggle('#' + selectedId);
        });

        $selectMenu.each(function(i) {
            $(this).on('change', (event) => {
                const selectedId = event.target.value;
                console.log(selectedId);
                if (i === 0) {
                    tabComponent.toggle('#' + selectedId);
                }
                if (i === 1) {
                    tabComponent2.toggle('#' + selectedId);
                }
                if (i === 2) {
                    tabComponent3.toggle('#' + selectedId);
                }
            });
        });

    }
}